import { render } from "./DiscoverLayoutHeader.vue?vue&type=template&id=640c3dae&ts=true"
import script from "./DiscoverLayoutHeader.vue?vue&type=script&lang=ts"
export * from "./DiscoverLayoutHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__